import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { NumberInput } from "@mantine/core";
import { imgNbaLogo } from "../../../../assets";

export default function KYCStep6() {
  const navigate = useNavigate();
  const [paymentAmount, setPaymentAmount] = useState("2000000");

  const professionalFee = 5000000;
  const balance = professionalFee - parseInt(paymentAmount.replace(/\D/g, ""));

  const handlePayNow = () => {
    navigate("/d/kyc/step7");
  };

  return (
    <div className="kyc-page">
      <div className="kyc-header">
        <div className="kyc-logo-section">
          <img className="kyc-logo-img" src={imgNbaLogo} alt="NBA Logo" />
          <div className="kyc-logo-text">
            <div className="kyc-logo-name">NIGERIAN BAR ASSOCIATION</div>
            <div className="kyc-logo-sub">REMUNERATION PORTAL</div>
          </div>
        </div>
      </div>

      <div className="kyc-progress">
        <button
          className="kyc-back-button"
          type="button"
          onClick={() => navigate("/d/kyc/step5")}
          aria-label="Go back"
        >
          <ArrowLeft size={20} />
        </button>
        <div className="kyc-progress-content">
          <span className="kyc-progress-text">Step 6 of 7</span>
          <div className="kyc-progress-bar">
            <div className="kyc-progress-fill" style={{ width: "85.7%" }} />
          </div>
        </div>
      </div>

      <div className="kyc-container">
        <div className="kyc-content">
          <h1 className="kyc-title">Installmental Payment</h1>
          <p className="kyc-subtitle">
            Choose how much you would like to pay
          </p>

          <div className="kyc-fee-breakdown">
            <div className="kyc-fee-breakdown-item">
              <div className="kyc-fee-breakdown-left">
                <span className="kyc-fee-breakdown-label">Professional Fee</span>
                <span className="kyc-fee-breakdown-amount">
                  ₦{professionalFee.toLocaleString()}
                </span>
              </div>
              <span className="kyc-fee-breakdown-note">
                Amount shown to client
              </span>
            </div>
          </div>

          <NumberInput
            label="Payment Amount"
            placeholder="Enter payment amount"
            value={parseInt(paymentAmount.replace(/\D/g, "") || "0")}
            onChange={(value) => {
              setPaymentAmount(value?.toString() || "0");
            }}
            prefix="₦"
            thousandSeparator=","
            min={0}
            max={professionalFee}
          />

          <div className="kyc-balance-info">
            <span className="kyc-balance-label">Balance:</span>
            <span className="kyc-balance-amount">
              ₦ {balance.toLocaleString()}
            </span>
          </div>

          <button
            className="dashboard-button dashboard-button--primary dashboard-button--large"
            type="button"
            onClick={handlePayNow}
          >
            <span>Pay Now</span>
          </button>
        </div>
      </div>
    </div>
  );
}

